import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=565ab1b1&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565ab1b1')) {
      api.createRecord('565ab1b1', component.options)
    } else {
      api.reload('565ab1b1', component.options)
    }
    module.hot.accept("./Resources.vue?vue&type=template&id=565ab1b1&", function () {
      api.rerender('565ab1b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Resources.vue"
export default component.exports